import { defineNotificationCategory, requireFields } from './types';

export const trialsDescriptor = defineNotificationCategory('trials', {
  isAvailable: requireFields('organizationDisplayName'),
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/subscriptions`,
  serverCopy: {
    titleKey: 'trials.title',
    bodyKey: 'trials.body',
    values: (data) => ({ org: data.organizationDisplayName, days: data.daysRemaining ?? 7 }),
  },
  pills: () => ['Trial'],
});

export const capacityOrphanedInstanceDescriptor = defineNotificationCategory(
  'capacity_orphaned_instance',
  {
    isAvailable: () => true,
    actionUrl: (_data, organizationId) =>
      `/org-id/${organizationId}/settings/capacity/orphaned-data`,
    serverCopy: {
      titleKey: 'capacityOrphanedInstance.title',
      bodyKey: 'capacityOrphanedInstance.body',
      values: (data, tn) => ({
        instance: data.instanceName ?? tn('capacityOrphanedInstance.thisInstance'),
      }),
    },
    pills: (data) => (data.instanceName ? [data.instanceName, 'Capacity'] : ['Capacity']),
  },
);
